import { c as _c } from "react/compiler-runtime";
import type { LpCardListItem } from '@cc-shopping/contracts/credit-cards-page/landing-page/CreditCardsLPCardList';
import { Box } from '@mui/material';
import { Card } from './Card';
type Props = {
  anchorPrefix: string;
  items: LpCardListItem[];
};
export function BenefitCards(t0) {
  const $ = _c(18);
  const {
    anchorPrefix,
    items
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: 1,
      sm: 2,
      md: 4
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const columns = t1;
  const t2 = `repeat(${Math.min(items.length, columns.md)}, 1fr)`;
  let t3;
  if ($[1] !== t2) {
    t3 = {
      xs: `repeat(${columns.xs}, 1fr)`,
      sm: `repeat(${columns.sm}, 1fr)`,
      md: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `repeat(${Math.ceil(items.length / columns.xs)}, 1fr)`;
  const t5 = `repeat(${Math.ceil(items.length / columns.sm)}, 1fr)`;
  const t6 = `repeat(${Math.ceil(items.length / columns.md)}, 1fr)`;
  let t7;
  if ($[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
    t7 = {
      xs: t4,
      sm: t5,
      md: t6
    };
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t3 || $[8] !== t7) {
    t8 = {
      display: "grid",
      gridTemplateColumns: t3,
      gridTemplateRows: t7,
      gap: 3
    };
    $[7] = t3;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== anchorPrefix || $[11] !== items) {
    let t10;
    if ($[13] !== anchorPrefix) {
      t10 = item => <Card key={item.title} anchorPrefix={anchorPrefix} item={item} />;
      $[13] = anchorPrefix;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    t9 = items.map(t10);
    $[10] = anchorPrefix;
    $[11] = items;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <Box sx={t8}>{t9}</Box>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}